export const GET_RESULT = "GET_RESULT";
export const GET_RESULT_REQUEST = "GET_RESULT_REQUEST";
export const GET_RESULT_SUCCESS = "GET_RESULT_SUCCESS";
export const GET_RESULT_FAILURE = "GET_RESULT_FAILURE";
